<div *ngIf="user" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
  <div fxFlex="25px" class="profile-picture" [ngStyle]="{
    'background-image': 'url(' + image + ')'
  }"></div>
  <div [ngClass]="lightText? 'user-name light-text': 'user-name'">{{user | nameWithUnit }}</div>
</div>
